import { Grid, Tabs, Tab } from '@material-ui/core';
import DynamicFeedIcon from '@material-ui/icons/DynamicFeed';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import ReceiptIcon from '@material-ui/icons/Receipt';
import WhatshotIcon from '@material-ui/icons/Whatshot';
import React, { useContext, useEffect, useState } from 'react';

import Channels from './Channels';
import DangerZone from './DangerZone';
import Notifications from './Notifications';
import Billing from './Billing';

import { ctx, IStore } from 'store';

import { useStyles } from './styles';

const Settings: React.FC = () => {
  const {
    teams: { currentTeam },
  } = useContext(ctx.store);
  const actions = useContext(ctx.actions);
  const classes = useStyles();
  const [value, setValue] = useState(0);

  useEffect(() => {
    const fetch = async () => {
      await ((actions.misc.setLoading(true) as unknown) as Promise<IStore>);
      if (currentTeam.teamId) {
        await ((actions.teams.getTeam(currentTeam.teamId) as unknown) as Promise<IStore>);
      } else {
        await ((actions.tenants.getTenant(currentTeam.tenantId) as unknown) as Promise<IStore>);
      }
      await ((actions.misc.setLoading(false) as unknown) as Promise<IStore>);
    };

    fetch();
  }, []);

  const handleChangeTab = (_event: any, newValue: number) => {
    setValue(newValue);
  };

  const determineTab = () => {
    switch (value) {
      case 0:
        return <Notifications />;
      case 1:
        return <Channels />;
      case 2:
        return <Billing />;
      case 3:
        return <DangerZone />;
      default:
        return <Notifications />;
    }
  };

  return (
    <Grid container>
      <Tabs
        value={value}
        onChange={handleChangeTab}
        indicatorColor="primary"
        textColor="primary"
        className={classes.tabs}
        variant="fullWidth"
      >
        <Tab label="Team & Notifications" icon={<NotificationsActiveIcon />} />
        <Tab
          label={currentTeam.teamId ? 'Channel Management' : 'Team Management'}
          icon={<DynamicFeedIcon />}
        />
        <Tab label="Billing" icon={<ReceiptIcon />} />
        <Tab label="Danger Zone" icon={<WhatshotIcon />} />
      </Tabs>
      {determineTab()}
    </Grid>
  );
};

export { Settings };
